import React from 'react';
import { useTestAB } from '@catalogo/core-experiments';
import { SwitchComponent } from '@catalogo/core-switch-component';

declare global {
  interface Window {
    spa: boolean;
  }
}

export const RenderHeaderTestAB: React.FC<Props> = ({ routeProps }) => {
  const headerTestAb = useTestAB('header-test-ab');

  const render = headerTestAb === 'new' && routeProps?.parsedQs?.['header'] !== 'false';

  if (!render) {
    return null;
  }

  return <SwitchComponent {...routeProps} component="header" />;
};

export const RenderFooterTestAB: React.FC<Props> = ({ routeProps }) => {
  const headerTestAb = useTestAB('header-test-ab');

  const render = headerTestAb === 'new' && routeProps?.parsedQs?.['footer'] !== 'false';

  if (!render) {
    return null;
  }

  return <SwitchComponent {...routeProps} component="footer" />;
};
interface Props {
  routeProps: RouteProps;
}
interface RouteProps {
  parsedQs: { [key: string]: string };
}
